var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownwardPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 5 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89333 3.78388L4.87527 1.02162C5.06147 0.762113 5.03632 0.371423 4.81908 0.148988C4.72519 0.0528467 4.6056 0 4.48194 0H0.51805C0.231939 0 0 0.277076 0 0.618867C0 0.766597 0.0442374 0.909454 0.124717 1.02162L2.10666 3.78388C2.29286 4.04338 2.61991 4.07344 2.83714 3.851C2.85728 3.83038 2.87606 3.80794 2.89333 3.78388Z",
    fill: "#141823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardPointer);
export default __webpack_public_path__ + "static/media/downwardPointer.2970efd29db7642e28dc7ae15e1d6def.svg";
export { ForwardRef as ReactComponent };